import { useConnectionState, useRoomContext } from "@livekit/components-react"
import { ConnectionState } from "livekit-client"
import { useCallback, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setCurrentActivity as setCurrentActivityAction } from "../../data/redux/actions/activity/index"
import useThrottledSetAttributes from "../../engine/live/room/useThrottledSetAttributes"

export const useCurrentActivity = () => {
    const dispatch = useDispatch()
    const { isLiveModeEnabled } = useSelector((state) => state.liveMode)
    const room = useRoomContext()
    const connectionState = useConnectionState()
    const { activity: currentActivity } = useSelector(
        (state) => state.data?.currentActivity
    )
    const isConnected =
        connectionState?.toString() === ConnectionState.Connected

    const setAttributesThrottled = useThrottledSetAttributes()

    useEffect(() => {
        if (
            isConnected &&
            currentActivity &&
            room?.localParticipant &&
            isLiveModeEnabled
        ) {
            setAttributesThrottled({
                activity_id: currentActivity?.activityData?.id?.toString() ?? "",
            }).catch((error) => {
                console.error("Failed to update attributes:", error.message)
            })
        }
    }, [isConnected, isLiveModeEnabled, currentActivity?.id])

    const setCurrentActivity = useCallback(
        (activity) => {
            dispatch(setCurrentActivityAction(activity))
            setAttributesThrottled({
                activity_id: activity?.activityData?.id?.toString() ?? "",
            }).catch((error) => {
                console.error("Failed to update attributes:", error.message)
            })
        },
        [setAttributesThrottled, dispatch]
    )

    const getCurrentActivity = useCallback(() => {
        return currentActivity
    }, [currentActivity])

    const markCurrentActivityAsDeleted = useCallback(() => {
        dispatch(
            setCurrentActivityAction({
                activityData: {
                    ...currentActivity?.activityData,
                    isDeleted: true,
                },
                progressStatus: currentActivity?.progressStatus,
            })
        )
    }, [currentActivity?.id, dispatch])

    return {
        currentActivity,
        setCurrentActivity,
        getCurrentActivity,
        markCurrentActivityAsDeleted,
    }
}
